module.exports = __webpack_public_path__ + "1025410cd259c16708727e4f8cc45b10.svg";